import { render, staticRenderFns } from "./SidebarAddNewCoupon.vue?vue&type=template&id=616ecaba&"
import script from "./SidebarAddNewCoupon.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewCoupon.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports